import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { NavigationEnd, Router } from "@angular/router";
import { AbsAuthService } from '../../shared/services/auth.svc';
import { HelperService } from '../../shared/services/helper.svc';
import { DataServiceProvider } from 'src/app/_providers';
import { HttpClient } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { DataService } from "src/app/shared/services/data.svc";
import { delay, filter } from "rxjs";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  providers:[{provide: AbsAuthService, useClass: null}]
})
export class LoginComponent implements OnInit {
  public newUser = false;
  // public user: firebase.User;
  public loginForm: FormGroup;
  public show: boolean = false
  public errorMessage: any;
  

  pageData = {
    email: '', password: '', isSubmitting: false
  }

  email: any; password: any; rememberme: boolean = false;
  chkRememberMe: boolean = false;
  chkBox: boolean = false;
  url: any;

  constructor(private fb: FormBuilder, public router: Router, public auth: AbsAuthService, private http: HttpClient,
    private svcHelper: HelperService, private _cookieService:CookieService, private svcData: DataService) {  

      
      if(_cookieService.get('email')) {this.email=this._cookieService.get('email');}
      if(_cookieService.get('password')) {this.password=this._cookieService.get('password');}
      
    this.loginForm = this.fb.group({
      email: [this.email!=null?this.email:"", [Validators.required, Validators.email]],
      password: [this.password!=null?this.password:"", Validators.required],
    });
    this.auth = DataServiceProvider.useFactory(this.http, this._cookieService);
  }

  ngOnInit() {
    
  }

  rememberMe(evt: any){
    this.rememberme = evt.target['checked']
  }

  loginEnter(){
    if(this.loginForm.valid){
      this.login();
    }
  }

  login() {  
    
    var _email = this.svcHelper.aesEncrypt(this.loginForm.value["email"].toString());
    var _password = this.svcHelper.aesEncrypt(this.loginForm.value["password"].toString());
    
    this.auth.login(_email, _password).subscribe(res=>{
      
      this.pageData.isSubmitting = false;
      if(res.status != 'OK'){
        this.showAlert(res.message);
        //this.svcData.usageAdd('{"userId":" ","code":"LOGIN-FAILED-API","actionCode":"LOGIN-API","remark":"'+this.pageData.email+'"}').subscribe();
        return;
      }

      if(res.data.userId!=null){
        // this.svcFcm.requestToken(res.data.userId);//specific user
        this.svcData.usageAdd('{"userId":"'+res.data.userId+'","code":"LOGIN-OK-API","actionCode":"LOGIN-API"}').subscribe();
        // this.svcData.sessionAdd('{"userId":"'+res.data.userId+'","fullName":"'+res.data.token+'","status":'+1+'}').subscribe();
      }

      this.svcData.areaDetail('5487C344-00CC-4020-9A46-CF249395908D').subscribe(res=>{
        if(res.status != 'OK'){
          this.showAlert(res.message);
          return;
        }
        var _areaDetail = res.data;
        
        var ha = _areaDetail.configs['hideanalytics'] == '1';
        var hmo = _areaDetail.configs['hidemonthlyoverview'] == '1';
        var hrmk = _areaDetail.configs['hideremarks'] == '1';
        var monthurs = _areaDetail.configs['Mon-Thurs'] == '1';
        var satsun = _areaDetail.configs['Sat-Sun'] == '1';
        var friday = _areaDetail.configs['Friday'] == '1';
        //console.log(this.svcData.dsHideAnalytics);
        this.auth.setCurrentShowHide('hideanalytics', ha);
        this.auth.setCurrentShowHide('hidemonthlyoverview', hmo);
        this.auth.setCurrentShowHide('hideremarks', hrmk);
        this.auth.setCurrentShowHide('Mon-Thurs', monthurs);
        this.auth.setCurrentShowHide('Sat-Sun', satsun);
        this.auth.setCurrentShowHide('Friday', friday);
      })

      var _oUser = res.data;
      //console.log(_oUser);
      this.auth.setCurrentUser(_oUser);
      

      if(this.rememberme == true){
        this._cookieService.set('email',this.loginForm.value["email"].toString());
        this._cookieService.set('password',this.loginForm.value["password"].toString());
      }
      else{
        this._cookieService.deleteAll();
      }       

      this.router.navigate(['/dashboard/default']);
    });

  }

  showPassword(){
    this.show = !this.show
  }

  showAlert(msg){
    //M.NgbToast({html: msg});
    alert(msg)
  }
}
